import { ca } from '@cian/analytics';

export function trackingFavoritesItemClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'to_card',
    label: 'favorites_popup',
  });
}
